import { createReducer, on } from '@ngrx/store';
import { ReportNamingConvention } from '../../enums/naming-convention.enum';
import { setNamingConvention } from './naming-convention.actions';
export const namingConvention = createReducer(ReportNamingConvention.TRUNCATED, on(setNamingConvention, (state, action) => {
    return action.namingConvention;
}));
